function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M19 14c.78 0 1.42.595 1.493 1.356l.007.144v1c0 .78-.595 1.42-1.356 1.493L19 18H6c-.78 0-1.42-.595-1.493-1.356L4.5 16.5v-1c0-.78.595-1.42 1.356-1.493L6 14h13zM6.687 15H6c-.215 0-.398.135-.469.326l-.023.084-.008.09v1c0 .245.177.45.41.492L6 17h.687v-2zM19 15H7.687v2H19c.245 0 .45-.177.492-.41l.008-.09v-1c0-.245-.177-.45-.41-.492L19 15zM7.5 4.5c.276 0 .5.224.5.5 0 1.001-.352 2.234-1.056 3.73C6.31 9.946 6 11.036 6 12c0 .276-.224.5-.5.5S5 12.276 5 12c0-1.14.355-2.384 1.048-3.713C6.686 6.93 7 5.83 7 5c0-.276.224-.5.5-.5zm3 0c.276 0 .5.224.5.5 0 1.097-.473 2.274-1.397 3.532l-.205.27C8.458 10.04 8 11.11 8 12c0 .276-.224.5-.5.5S7 12.276 7 12c0-1.143.542-2.407 1.605-3.807C9.543 6.988 10 5.922 10 5c0-.276.224-.5.5-.5z"
});

var SvgIconSmoking = function SvgIconSmoking(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconSmoking, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-smoking.56cc3bac.svg";
export { ForwardRef as ReactComponent };